import {StoreProvider} from 'lowkey-component';

import {INavState} from '@services/types';
import {isOpenGlobalNavSaved} from '@store/appSlice';
import {
  headerNavDisplaySaved,
  HeaderNavDisplayState,
  isShowHeaderNavMenuSaved,
} from '@store/navSlice';

export const createNavState = (): INavState => {
  const store = StoreProvider.create();
  return {
    updateIsOpenGlobalNav: (isOpen) => {
      store.dispatch(isOpenGlobalNavSaved(isOpen));
    },
    updateIsShowHeaderNavMenu: (isShow) => {
      store.dispatch(isShowHeaderNavMenuSaved(isShow));
    },
    updateHeaderNavDisplayState: (state: HeaderNavDisplayState) => {
      store.dispatch(headerNavDisplaySaved(state));
    },
  };
};
